import styled from 'styled-components';

import { Box } from '../ui/Box';
import { get } from '../ui/get';

export const ButtonGroup = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${get('space.4')}px;
    flex-wrap: nowrap;
`;
